import React from 'react';
import { FormattedMessage } from 'react-intl';

import StyledLoading from './StyledLoading';

const Loading: React.FC = () => {
  return (
    <StyledLoading>
      <h1>
        <FormattedMessage id="loading" />
        ...
      </h1>
    </StyledLoading>
  );
};

export default Loading;
